$(function() {
    // $('.expanding-main').find('ul.toolkit-downloads li > a').on('click', function () {
    //     $('.download-popup-container').addClass('open');
    // });

    $('.close-btn').on('click', function() {
        $(this).parents('.download-popup-container').removeClass('open');
    })
});